(function(Manogi, $, undefined) {

    //Private

    //Public

    Manogi.changeQuantityToAvailable = function($input) {
        var $form = $input.closest('form');
        var available = $form.data('available');
        $input.val(available);
    };

    Manogi.validateInCartQuantity = function($quantity) {
        var $in_cart = $quantity.closest('.js-in-cart');
        var id = $in_cart.data('id');
        var quantity = $quantity.val();
        if(quantity != ''){
            quantity = parseInt(quantity);
        }

        if(isNaN(quantity) && quantity != ''){
            quantity = 1;
        }
        var available = parseInt($in_cart.attr('data-available'));
        if(quantity > available && available > 0){
            $quantity.val(available);
            var message = Manogi.translate('only_wildcard_available').replace('{wildcard}', available);
            var content = message;
            content += '<br>'+Manogi.translate('delivery_time_for_quantity_needs_request');
            content += '<br><br><a href="#" class="tooltipster-button js-buy-available" data-id="'+id+'">'+Manogi.translate('buy_wildcard').replace('{wildcard}', available)+'</a><a href="mailto:'+Manogi.setting('shop_email')+'?subject='+Manogi.setting('shop_title')+': '+Manogi.translate('request_delivery_time')+'&amp;body='+Manogi.translate('request_delivery_time_for').replace('{wildcard}', quantity)+':%0D%0A%0D%0A'+$in_cart.data('name')+'" class="tooltipster-button js-request-delivery-time">'+Manogi.translate('request_delivery_time')+'</a><a href="#" class="tooltipster-button js-cancel-buy-tooltip" data-id="'+id+'">'+Manogi.translate('cancel')+'</a>';
            if($quantity.hasClass('tooltipstered')){
                $quantity.tooltipster('content', content);
            }
            else {
                $quantity.tooltipster({
                   content: content,
                   contentAsHTML: true,
                   trigger: 'custom',
                   timer: 10000,
                   interactive: true,
                   position: 'bottom',
                   theme: 'tooltipster-alert'
                });
            }

            $quantity.tooltipster('show');

        }

    };

    Manogi.useInCart = function($in_cart) {
        $.oc.stripeLoadIndicator.show();
        var id = parseInt($in_cart.data('id'));
        $quantity = $in_cart.find('*[name=quantity]');
        quantity = parseInt($quantity.val());
        var available = parseInt($in_cart.attr('data-available'));
        var is_bundle = 0;
        if($in_cart.attr('data-is_bundle')){
            is_bundle = parseInt($in_cart.attr('data-is_bundle'));
        }
        var new_available = available - quantity;
        $in_cart.attr('data-available', new_available);
        $('.js-available').text(new_available > 60 ? '> 60' : new_available);

        if (!new_available) {
            $('.js-in-cart').hide();
        }

        $in_cart.request('cartHandler::onAddToCart', {
            data: {
                id: id,
                is_bundle: is_bundle
            },
            success: function(response) {
                $.oc.stripeLoadIndicator.hide();
                Manogi.openModal({
                    message : response['message'],
                    confirm_text : Manogi.translate('go_to_shopping_cart'),
                    cancel_text : Manogi.translate('continue_shopping'),
                    show_confirm : true,
                    confirm_action : function() { window.location.href='/'+Manogi.lang+'/cart'; },
                });
                // var price_incl_vat = parseFloat($in_cart.attr('data-price_incl_vat'));
                // var add_to_total = price_incl_vat*quantity;
                // var $minicart_total = $('.minicart__total');
                // var current_total = parseFloat($minicart_total.attr('data-total'));
                // var new_total = current_total+add_to_total;
                // var total_string = numeral(new_total).format('0,0.00');
                // $minicart_total.attr('data-total', new_total);
                // $minicart_total.text(total_string);
                // $in_cart.find('input[name=quantity]').val(1);
            }
        });
    };

    Manogi.changeCartQuantity = function($input) {
        var quantity = parseInt($input.val());
        var available = parseInt($input.data('available'));
        if (quantity > available) {
            $input.val(available);
        }
        $input.addClass('changed');
        var id = parseInt($input.data('id'));
        $('.js-change-cart-quantity').removeClass('u-none');
    };

    Manogi.persistCartQuantity = function($input) {
        $.oc.stripeLoadIndicator.show();
        var id = parseInt($input.data('id'));
        quantity = parseInt($input.val());

        $input.request('cartHandler::onChangeQuantity', {
            data: {
                id : id,
                quantity : quantity
            },
            success: function(response) {
                window.location.reload();
            }
        });
    };

    Manogi.removeCartArticle = function($button) {
        $.oc.stripeLoadIndicator.show();
        var id = parseInt($button.data('id'));

        $button.request('cartHandler::onRemoveArticle', {
            data: {
                id : id
            },
            success: function(response) {
                window.location.reload();
            }
        });
    };

    Manogi.removeCartCoupon = function($button) {
        $.oc.stripeLoadIndicator.show();

        $button.request('cartHandler::onRemoveCoupon', {
            success: function(response) {
                window.location.reload();
            }
        });
    };



}( window.Manogi = window.Manogi || {}, jQuery ));
